import { useEffect } from "react";
import { videoTag } from "../constants";
import { handleVideoTimeline } from "../../redux/actions/controller.actions";
import { useAppSelector } from "redux-share";
import { shallowEqual } from "react-redux";
import { handleContinuousPlayback } from "ui/src/playerComponents/continuousPlayback/continuousePlayback";

const useBeforeUnload = () => {
    useAppSelector(({ user: { isLogin } }) => ({ isLogin }), shallowEqual);

    useEffect(() => {
        const handleBeforeUnload = () => {
            handleVideoTimeline(videoTag().currentTime);
            handleContinuousPlayback();
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    }, []);
};

export default useBeforeUnload;
